var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "service-page__content" },
    [
      _c("header", { staticClass: "terms__header" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("footer.terms")))])
      ]),
      _vm._v(" "),
      _c("terms-of-services-text")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }